export function makeEmailValidation<T>(errorMsg: T) {
  // eslint-disable-next-line
  const re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,6}$/;

  return (email: string) => (re.test(String(email).toLowerCase()) ? undefined : errorMsg);
}
